'use client';

import { Check } from 'lucide-react';
import React from 'react';

interface SelectionCardProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  image?: string;
}

export const SelectionCard: React.FC<SelectionCardProps> = ({ 
  label, 
  selected, 
  onClick, 
  image: _image 
}) => {
  return (
    <div 
      onClick={onClick}
      className={`
        relative group cursor-pointer rounded-xl overflow-hidden border-2 transition-all duration-300
        ${selected 
          ? 'border-gold-400 bg-gold-500/15 shadow-[0_0_25px_rgba(214,183,84,0.3)] ring-1 ring-gold-400/40' 
          : 'border-stone-700/60 bg-stone-900 hover:border-stone-500 hover:bg-stone-800'}
      `}
    >
      <div className="p-6 h-32 flex items-center justify-center text-center relative z-10">
        <span className={`text-xl font-medium ${selected ? 'text-gold-200' : 'text-stone-300'}`}>
          {label}
        </span>
      </div>
      
      {selected && (
        <div className="absolute top-3 right-3 z-20 bg-gold-400 text-stone-950 rounded-full p-1 shadow-lg shadow-gold-400/30">
          <Check size={16} strokeWidth={3} />
        </div>
      )}
    </div>
  );
};
